// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__zGSLS","transparent":"Button_transparent__E4Ryi","link":"Button_link__WEm0i","filled":"Button_filled__HCh_t","outline":"Button_outline__ui57U"};